import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

class ClientsPage extends React.Component {

  constructor(){

      super()


      let cols = this.calculateCols();

      this.state = {
        cols
      }
      //this.calculateCols = this.calculateCols.bind(this)
      this.resize = this.resize.bind(this)
  }


  calculateCols(){
    let cols = 5

    if(window.innerWidth < 740){
      cols = 4
    }

    if(window.innerWidth < 540){
      cols = 3
    }

    if(window.innerWidth < 440){
      cols = 2
    }

    if(window.innerWidth < 319){
      cols = 1
    }

    return cols
  }

  resize(){

    let cols = this.calculateCols();

    if(cols !== this.state.cols){
      this.setState({cols})
    }
  }

  componentDidMount(){
      window.addEventListener('resize',this.resize)
  }

  componentWillUnmount(){
    window.removeEventListener('resize',this.resize)
  }

  render () {



    let rows = [[]]
    let currentRow = 0;
    let cols = this.state.cols

    //console.log(this.props);


    let clients = this.props.clientsData.data || []




    clients.map((item,i)=>{



        rows[currentRow].push(item)

        if(i % cols === cols-1){
          rows.push([])
          currentRow++
        }

    })


    let thumbMaxWidth = 100 / rows[0].length;

    console.log('thumbMaxWidth',thumbMaxWidth);

    return(<div className="clients-page scroll-anchor">

            {
              rows.map((row,i)=>{
                return (<div key={'r'+i} className="row">
                  {
                    rows[i].map((client,j)=>{

                        let style={
                          backgroundImage : 'url('+client.acf.logo.url+')'

                        }
                        return(
                              <div key={'c'+j} className="client" style={{maxWidth: thumbMaxWidth+'%'}}>
                                    <div className="inner-client" style={style} >
                                      {
                                          (client.acf.client_website)?
                                            <a href={client.acf.client_website}  title={client.title.rendered} target="_blank">

                                            </a>
                                          : null
                                      }
                                    </div>
                              </div>
                        )
                    })

                  }</div>);


              })
            }

        </div>)
  }
}

const mapStateToProps = (state)=>{

  let clientsData = state.KastnerStore.clientsData

  return {
    clientsData
  }

}

export default connect(mapStateToProps)(ClientsPage);



// WEBPACK FOOTER //
// ./src/modules/pages/ClientsPage.js